.builder {
  display: flex;
  gap: 24px;
  padding-bottom: 32px !important;
  width: 100%;

  .builderMain {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .builderSidebar {
    flex: 0 0 540px;
    position: sticky;
    top: 30px;
    height: fit-content;
  }
}

.stickyHeader {
  position: sticky;
  top: 0;
  z-index: 5;
}

.headerActions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.contentCard,
.loaderCard,
.errorCard {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: visible;
}

.loaderCard,
.errorCard {
  min-height: 260px;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.sectionNumber {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 25%;
  font-weight: 600;
  font-size: 13px;
  @include themify($themes) {
    color: #fff;
    background-color: themed("btn-primary");
  }
}

.contentHeader {
  padding: 16px 16px 0;
}

.sectionTitleWrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sectionTitleText {
  display: flex;
  flex-direction: column;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.1;
  }

  p {
    margin: 0;
    font-size: 14px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }
}

.sectionTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stepContent {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.fieldGrid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(160px, 1fr);
  gap: 20px;
}

.fieldRow {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(140px, 1fr);
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 15px;
    font-weight: 500;
  }

  textarea {
    height: 110px;
  }
}

.textArea {
  display: flex;
}

.inlineField {
  display: inline-flex;
  align-items: center;
  gap: 12px;

  label {
    user-select: none;
    cursor: pointer;
  }
}

.scopeGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.scopeCard {
  border-radius: 12px;
  border: 1px solid transparent;
  padding: 16px 18px;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    opacity 0.2s ease;
  @include themify($themes) {
    @include dark-mode() {
      background-color: rgba(themed("neutral-tertiary"), 0.45);
    }
    border-color: themed("neutral-secondary");
    color: themed("main-primary");
  }

  &:hover {
    @include themify($themes) {
      background-color: rgba(themed("neutral-tertiary"), 0.65);
    }
  }
}

.summaryGrid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.scopeCardActive {
  @include themify($themes) {
    border-color: themed("brand-primary");
    background-color: rgba(themed("brand-primary"), 0.06) !important;
    box-shadow: 0 0 0 1px rgba(themed("brand-primary"), 0.08);
  }
}

.scopeCardTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 18px;
  font-weight: 500;
  font-size: 15px;

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.5;
  }
}

.scopeCardDescription {
  font-size: 12px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.conditionPillGroup {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.conditionDropdown {
  position: relative;
  display: inline-flex;
}

.directionPillGroup {
  column-gap: 0;
  row-gap: 6px;
  margin: 0 -6px;
}

.directionPillItem {
  max-width: 240px;
  margin: 0 6px;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  transition:
    max-width 0.24s ease,
    opacity 0.18s ease,
    margin 0.24s ease;
}

.directionPillItemHidden {
  max-width: 0;
  opacity: 0;
  margin-left: 0;
  margin-right: 0;
  pointer-events: none;
}

@keyframes ruleGroupPillEnter {
  from {
    opacity: 0;
    transform: translateX(-10px) scaleX(0.9);
  }
  to {
    opacity: 1;
    transform: translateX(0) scaleX(1);
  }
}

.ruleGroupItem {
  display: inline-flex;
  align-items: center;
  gap: 12px;

  .conditionDropdownPill {
    transform-origin: left center;
    animation: ruleGroupPillEnter 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  }

  > .andLabel {
    animation: ruleGroupPillEnter 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  }
}

.conditionPill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 35px;
  padding: 0 16px;
  border-radius: 999px;
  border: 1px solid transparent;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    color 0.2s ease,
    opacity 0.2s ease;
  @include themify($themes) {
    border-color: themed("neutral-secondary");
    background-color: rgba(themed("main-secondary"), 0.75);
    color: themed("neutral-primary");
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &.conditionPillActive {
    @include themify($themes) {
      color: themed("btn-primary");
      @include dark-mode() {
        color: themed("btn-primary-text");
      }
      border-color: themed("brand-primary");
      background-color: rgba(themed("brand-primary"), 0.06) !important;
      box-shadow: 0 0 0 1px rgba(themed("brand-primary"), 0.08);
    }

    svg {
      transform: rotate(45deg);
    }
  }

  &.conditionPillDisabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &:not(.conditionPillActive):not(.conditionPillDisabled) {
    &:hover {
      @include themify($themes) {
        border-color: rgba(themed("neutral-primary"), 0.5);
        color: themed("main-primary");
      }
    }
  }
}

.conditionDropdownPill {
  padding: 0 6px 0 4px;
  gap: 1px;
}

.conditionPillSymbol {
  width: 14px;
  height: 14px;
  line-height: 1;
}

.conditionPillIconButton,
.conditionPillContentButton {
  border: 0;
  background: transparent;
  color: inherit;
  padding: 0;

  &:not(:disabled) {
    cursor: pointer;
  }
}

.conditionPillIconButton {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  border-radius: 999px;
  padding: 4px;
  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    @include themify($themes) {
      background-color: themed("background");
    }
  }
}

.conditionPillContentButton {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 35px;
  padding: 0 10px 0 0;
  font-size: 14px;
}

.conditionPillLabel {
  flex-shrink: 0;
}

.conditionPillSummary {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.conditionPillCount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  @include themify($themes) {
    background-color: themed("btn-primary");
    color: themed("btn-primary-text");
  }
}

.conditionDropdownMenu {
  z-index: 6;
  width: min(420px, calc(100vw - 64px));
  padding: 14px 16px 16px;
  border-radius: 16px;
  box-shadow: 0 18px 44px rgba(0, 0, 0, 0.16);
  @include themify($themes) {
    border: 1px solid themed("neutral-secondary");
    background-color: themed("main-secondary");
  }
  max-height: 450px;
  overflow-y: auto;

  &:has([data-is-select-menu="true"]) {
    overflow: visible;
  }
}

.conditionPanel {
  display: flex;
  flex-direction: column;
  gap: 10px;

  label {
    font-size: 15px;
    font-weight: 500;
  }
}

.sectionHeader {
  display: flex;
  flex-direction: column;

  h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
  }

  p {
    margin: 0;
    font-size: 13px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.35;
  }
}

.inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.requiredIndicator {
  font-size: 10px;
  font-weight: 200;
  @include themify($themes) {
    color: themed("error-primary");
  }
}

.ruleShell {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 18px;
  border-radius: 16px;
  border: 1px dashed;
  @include themify($themes) {
    border-color: themed("neutral-secondary");
    background-color: rgba(themed("main-secondary"), 0.65);
  }
}

.andLabel,
.helperText {
  font-size: 12px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.andLabel {
  display: inline-flex;
  align-items: center;
  min-height: 35px;
  font-weight: 700;
}

.helperText {
  margin: 0;
}

.summaryHero {
  gap: 10px;
  border-radius: 18px;

  h3,
  p {
    margin: 0;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
  }

  p {
    line-height: 1.8;
    opacity: 0.8;
    font-size: 15px;
  }
}

.summaryCard {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 16px;

  h4,
  p {
    margin: 0;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
  }
}

.summaryCardContent {
  display: flex;
  flex-direction: column;
}

.summaryList {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;

  .summaryListRow {
    display: grid;
    grid-template-columns: minmax(140px, 0.95fr) minmax(0, 1.35fr);
    align-items: flex-start;
    gap: 16px;

    &:not(:first-child) {
      padding-top: 10px;
      @include themify($themes) {
        border-top: 1px solid themed("neutral-secondary");
      }
    }
  }

  .summaryListRowStacked {
    grid-template-columns: 1fr;
    gap: 6px;

    dd {
      width: 100%;
      text-align: left;
      align-items: flex-start;
    }

    .summaryListValue {
      width: 100%;
    }
  }

  dt {
    font-weight: 500;
    font-size: 14px;
    min-width: 0;
  }

  dd {
    margin: 0;
    text-align: right;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    font-size: 14px;
  }
}

.summaryListValue {
  white-space: normal;
  overflow-wrap: anywhere;
}

.fitButton {
  width: fit-content;
}

.iconButton {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify($themes) {
    background-color: themed("neutral-tertiary");
  }

  svg {
    width: 16px;
    height: 16px;
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }
}

.selectControl {
  min-height: 42px;
  max-height: 196px;
  overflow-y: auto;
  align-items: flex-start;
}

.textInput {
  height: 42px;
}

@media (min-width: 1440px) {
  .scopeGrid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1820px) {
  .builder {
    .builderSidebar {
      flex: 0 0 425px;
    }
  }
}

@media (max-width: 1540px) {
  .builder {
    flex-direction: column;
  }
}

@media (max-width: 1024px) {
  .scopeGrid,
  .fieldGrid,
  .fieldRow {
    grid-template-columns: 1fr;
  }

  .headerActions,
  .ruleGroupHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .sectionTitleRow {
    flex-direction: column;
    align-items: flex-start;
  }
}
